import { render, staticRenderFns } from "./flow-starter.vue?vue&type=template&id=4f878243&shadow"
import script from "./flow-starter.vue?vue&type=script&lang=ts&shadow"
export * from "./flow-starter.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./flow-starter.vue?vue&type=style&index=0&id=4f878243&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports